WiseMetering.Model.AnalyzeView = WiseMetering.Model.extend({
    urlRoot: '/analyze_views'
});
